import { render, staticRenderFns } from "./SidebarPanel.vue?vue&type=template&id=99017360&scoped=true&"
import script from "./SidebarPanel.vue?vue&type=script&lang=js&"
export * from "./SidebarPanel.vue?vue&type=script&lang=js&"
import style0 from "./SidebarPanel.vue?vue&type=style&index=0&id=99017360&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99017360",
  null
  
)

export default component.exports